const submitWidget = (widgetConf) => {
  // Insert submit handling logic here
  return widgetConf;
};

export default submitWidget;
